import HistoricoVendaCapa from './HistoricoVendaCapa';

export default HistoricoVendaCapa;